<template>
  <div id="categorias">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="10">
            <v-card>
              <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer class="d-none d-sm-flex"></v-spacer>
                <!-- Create Item (Desktop) -->
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 d-none d-sm-flex"
                  @click="createItem"
                  >Crear Categoria</v-btn
                >
                <!-- END - Create Item (Desktop) -->
              </v-card-title>
              <v-card-text>
                <!-- Tabla de Opiniones -->
                <v-data-table
                  :headers="headers"
                  :items="state.body"
                  :search="search"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">
                      mdi-pencil
                    </v-icon>
                    <v-icon small class="mr-2" @click="orderProductos(item)">
                      mdi-format-list-bulleted
                    </v-icon>
                  </template>
                </v-data-table>
                <!-- End - Tabla de Opiniones -->
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { reactive, ref, computed } from "@vue/composition-api";

export default {
  name: "Categorias",
  setup(props, { root }) {
    const state = reactive({
      headersTitle: {
        id: "Id",
        categoria: "Categoria"
      },
      body: [],
      actions: {
        getData: "getCategoriasMenu"
      }
    });
    const title = ref("Categorias");
    const search = ref("");

    const headers = computed(() => [
      { text: state.headersTitle.id, value: "id" },
      { text: state.headersTitle.categoria, value: "categoria" },
      { text: "Acciones", value: "actions", sortable: false }
    ]);

    const init = () => {
      root.$store
        .dispatch(state.actions.getData)
        .then(response => {
          state.body = response;
        })
        .catch(error => {
          console.log(error);
        });
    };

    const createItem = () => {
      console.log("Crear Nueva Categoria");
    };

    const editItem = item => {
      console.log("Editar Categoria " + item.categoria);
    };

    const orderProductos = item => {
      root.$router.push(`categorias/${item.id}/${item.categoria}`);
    };

    init();

    return {
      state,
      title,
      search,
      headers,
      createItem,
      editItem,
      orderProductos
    };
  }
};
</script>
